import localforage from 'localforage';

const storage = localforage;

export { storage };
